import type { ResponseSuccessPayload } from './default-response-adapter';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyType = any;

// TODO: переписать getAsyncThunk, чтобы возвращал предыдущую структуру
// Текущая структура    { payload: { data: {}, status: number } }
// Предыдущая структура { payload: {} status: number }

// Сейчас многие экшены работают на старой структуре, поэтому, чтобы не сломать обратную совместимость
// Был написал этот конвертер

function convertActionToPreviousStructure(action: AnyType) {
  if (!isAsyncThunkPayload(action)) {
    return action;
  }

  const convertedAction: AnyType = { ...action };

  if (action.payload) {
    convertedAction.status = action.payload.status;
    convertedAction.payload = action.payload.data;
  }

  if (action.meta?.arg?.signature) {
    convertedAction.payload = {
      signature: action.meta.arg.signature,
      ...convertedAction.payload,
    };
  }

  return convertedAction;
}

type MetaPayload = { arg?: { signature?: string } };
type AsyncThunkPayload = { meta?: MetaPayload; payload?: ResponseSuccessPayload<AnyType> };

function isAsyncThunkPayload(action: unknown): action is AsyncThunkPayload {
  return action instanceof Object && 'meta' in action && 'payload' in action;
}

export { convertActionToPreviousStructure };
